import XhrRequestHandler from '../../lib/XhrRequestHandler';

export interface ProyectoGlosa {
  dicprog_id: string;
  dicprog_nombre_proyecto: string;
  dicprog_nombre_proyecto_glosa: string;
  dicprog_fecha_validez_inicio: string;
  dicprog_fecha_validez_fin: string;
  dicprog_activo: boolean;
  dicprog_eliminado: boolean;
  dicprog_fecha_creacion: string;
  dicprog_fecha_actualizacion: string | null;
  dicprog_id_colab_creo: string;
  dicprog_id_colab_actualizo: string | null;
}

export interface ProyectoGlosaSavePayload {
  dicprog_nombre_proyecto: string;
  dicprog_fecha_validez_inicio: string;
  dicprog_fecha_validez_fin: string;
  dicprog_activo: boolean;
  dicprog_id?: string;
}

export interface MassDeleteResponse {
  deleted: number;
  errors: string[];
}

export class ProyectosGlosaSystem {
  private readonly base = '/proyectos-glosa';

  constructor(private requestHandler: XhrRequestHandler) {}

  async getAll(): Promise<ProyectoGlosa[]> {
    const response = await this.requestHandler.get<ProyectoGlosa[]>(this.base);
    return response;
  }

  async getById(id: string): Promise<ProyectoGlosa> {
    const data = await this.requestHandler.get<ProyectoGlosa>(`${this.base}/${id}`);
    return data;
  }

  async save(data: ProyectoGlosaSavePayload): Promise<ProyectoGlosa> {
    const response = await this.requestHandler.post<ProyectoGlosa>(this.base, data);
    return response;
  }

  async delete(id: string): Promise<void> {
    return await this.requestHandler.delete(`${this.base}/${id}`);
  }

  async deleteMassive(ids: string[]): Promise<MassDeleteResponse> {
    const response = await this.requestHandler.post<MassDeleteResponse>(`${this.base}/mass-delete`, { ids });
    return response;
  }

  getBaseUrlForDatagrid(): string {
    return this.requestHandler.requestUrl(`${this.base}/datagrid`);
  }
}

export default ProyectosGlosaSystem;
